import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const ReportTabs = ({ reportType, setReportType }) => {
  const [tabValue, setTabValue] = useState(0);
  
  // Map report types to tab indices
  // const reportTypes = ['payroll-summary', 'tax-summary', 'investment', 'hra', 'employee-tax'];
  const reportTypes = ['tax-summary', 'investment', 'hra', 'cost-center-summary'];
  
  // Update tab value when reportType changes from parent
  useEffect(() => {
    const index = reportTypes.indexOf(reportType);
    if (index !== -1) {
      setTabValue(index);
    }
  }, [reportType]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setReportType(reportTypes[newValue]);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        // variant="scrollable"
        scrollButtons="auto"
        // indicatorColor="primary"
        // textColor="primary"
        sx={{ 
          borderBottom: 1, 
          borderColor: 'divider',
          '& .MuiTab-root': {
            // minWidth: 120,
            // textTransform: 'Uppercase',
            // fontWeight: 550,
            fontSize: '0.85rem',
            // color:"#666"
          },
          "& .Mui-selected": {
              color: "#1976d2",
            },
        }}
      >
        {/* <Tab label="Payroll Summary" /> */}
        <Tab label="Tax Summary" />
        <Tab label="Investment Summary" />
        <Tab label="Allowance Claims" />
        <Tab label="Cost Center Breakdown" />
      </Tabs>
    </Box>
  );
};

export default ReportTabs;